<template>
  <div>
    <ContentHeader :budget-nav="false" />
    <div class="content-container">
      <div class="search-top-row">
        <el-row>
          <el-col style="text-align:center">
            <el-input class="search-input" v-model="queryParam.keyword" placeholder="关键字搜索">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select v-model="queryParam.quotaStatus" placeholder="预算状态" clearable filterable>
              <el-option v-for="(item, idx) in quotaStatusList" :key="idx" :value="item.key" :label="item.value" />
            </el-select>
            <span class="search-text">价格区间</span>
            <el-input v-model="queryParam.leftAmount" class="range-input" @keyup.native="minNumber"></el-input>
            <span class="search-text">至</span>
            <el-input v-model="queryParam.rightAmount" class="range-input input-right" @keyup.native="maxNumber"></el-input>
            <span class="search-text">日期区间</span>
            <el-date-picker v-model="queryParam.effectiveDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            <span class="search-text">至</span>
            <el-date-picker class="input-right" v-model="queryParam.expireDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            <el-button class="btn-red" size="small" @click="budgetListDetail()">搜索</el-button>
            <el-button class="btn-blue-plain" size="small" @click="handleExport()">导出明细</el-button>
          </el-col>
        </el-row>
      </div>
      <div :loading="loading" class="budget-grid-info">
        <el-table :data="quotaDetailList" class="while-data-table" v-loading="loading">
          <el-table-column prop="quotaName" label="预算名称"></el-table-column>
          <el-table-column prop="orderNumber" label="订单号"></el-table-column>
          <el-table-column prop="quotaBelong" label="预算归属"></el-table-column>
          <el-table-column prop="usedDate" label="使用时间">
            <template slot-scope="scope">{{ scope.row.usedDate | parseTime('{y}-{m}-{d}') }}</template>
          </el-table-column>
          <el-table-column prop="usedAmount" label="扣减配额">
            <template slot-scope="scope"><span v-if="quotaTypeName">￥</span>{{ scope.row.usedAmount | thousandSymbol }}</template>
          </el-table-column>
          <el-table-column prop="quotaStatus" label="预算状态"></el-table-column>
        </el-table>
      </div>

      <v-form ref="form" :url="exportUrl" :params="queryParam" />

      <el-row class="while-data-table-footer">
        <el-col>
          <el-pagination
            background
            :current-page="queryParam.page"
            :page-size="queryParam.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import budgetApi from '@/api/budget'
import { mapState } from 'vuex'
import vForm from '@/components/v-form'
import ContentHeader from '../../../components/content-header'
import { commonUtils } from '@/utils/common'
export default {
  name: 'budget-grid-info',
  components: {
    vForm,
    ContentHeader
  },
  props: {},
  data () {
    return {
      loading: false,
      page: 1,
      pageSize: 10,
      queryParam: {
        quotaId: '',
        keyword: '',
        quotaStatus: '',
        leftAmount: '',
        rightAmount: '',
        effectiveDate: '',
        expireDate: ''
      },
      quotaDetailList: [],
      total: null,
      exportParam: {},
      exportUrl: null,
      quotaTypeName: false
    }
  },
  computed: {
    ...mapState({
      quotaStatusList: state => state.base.quotaQueryStatus
    })
  },
  created () {
    this.queryParam.quotaId = this.$route.query.quotaId
    this.init()
    this.quotaTypeName = parseInt(this.$route.query.type)
  },
  methods: {
    init () {
      this.budgetListDetail()
      this.$store.dispatch('getDictByName', 'quotaQueryStatus')
    },

    // 获取预算详情列表
    budgetListDetail (page) {
      this.loading = true
      let params = _.assign(this.queryParam, {
        page: this.page,
        pageSize: 10
      })
      budgetApi
        .budgetListDetail(params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.quotaDetailList = res.data.resultData.quotaDataList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    handleCurrentChange (val) {
      this.page = val
      this.budgetListDetail(this.page)
    },

    // 导出明细
    handleExport () {
      this.exportUrl = commonUtils.getApiUrl('/quota/used-history/export')
      this.$confirm('是否要导出明细?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input.el-input {
  width: 180px;
  height: 36px;
  margin: 0 20px 20px 0;
  input::-webkit-input-placeholder {
    color: #000;
  }
}
.el-select {
  width: 140px;
  height: 36px;
  margin: 0 20px 20px 0;
}
.search-text {
  font-size: $font-12;
  display: inline-block;
  height: 38px;
  padding: 0 5px;
  line-height: 38px;
  background-color: #d8d8d8;
}
.search-top-row .el-date-editor {
  width: 140px;
}
.range-input {
  width: 65px;

  ::v-deep .el-input__inner {
    padding: 0 5px;
  }
}
.input-right {
  margin-right: 20px;
}
.budget-grid-info {
  margin-top: 20px;
}
</style>
